<template>
  <div class="borderlog">
    <v-layout row v-if="showHisto" v-for="(histo, idx) in rowItem.histo" :key="idx">
      <v-flex class="centercontent" xs1 pr-1>
        {{ idx == 0 ? rowItem.utcDatadd : rowItem.histo[idx - 1].date | formatDate('DD/MM/YYYY') }}
      </v-flex>
      <v-flex class="centercontent" xs1 pl-1 pr-1>
        {{ idx == 0 ? rowItem.utcDatadd : rowItem.histo[idx - 1].date | formatDate('HH:mm:ss UTC') }}
      </v-flex>
      <v-flex class="centercontent" :xs3="!hideCycle" :xs2="hideCycle"></v-flex>
      <v-flex class="leftcontent" :xs7="!hideCycle" :xs8="hideCycle" pl-1>
        <span v-html="histo.message.replace(/\n/g, '<br/>')"></span>
      </v-flex>
    </v-layout>
    <v-layout row v-if="!editing">
      <template>
        <v-flex class="centercontent" xs1 pr-1>
          {{ showHisto ? rowItem.histo[rowItem.histo.length - 1].date : rowItem.utcDatadd | formatDate('DD/MM/YYYY') }}
        </v-flex>
        <v-flex class="centercontent" xs1 pl-1 pr-1>
          {{
            showHisto ? rowItem.histo[rowItem.histo.length - 1].date : rowItem.utcDatadd | formatDate('HH:mm:ss UTC')
          }}
        </v-flex>
        <v-flex class="centercontent" xs2 pl-1 pr-1>
          {{ rowItem.sender ? rowItem.sender : rowItem.usrPrenom + ' ' + rowItem.usrNom }}
        </v-flex>
        <v-flex v-if="!hideCycle" class="centercontent" xs1 pl-1 pr-1>{{ rowItem.gliCycle }}</v-flex>
        <v-flex class="leftcontent" :xs7="!hideCycle" :xs8="hideCycle" pl-1>
          <span style="flex: 1" v-html="rowItem.message.replace(/\n/g, '<br/>')"></span>
          <span
            class="modified"
            v-if="rowItem.histo.length > 0"
            @click="showHistory()"
            :class="{ 'cursor-pointer': isAdmin || isSysAdmin }"
          >
            ({{ $t('Pilot.LogBook.Modified') }})
          </span>
          <v-icon
            v-if="rowItem.usrId == userId"
            @click.stop.prevent="edit()"
            class="ml-1"
            :title="$t('Pilot.LogBook.EditMessage')"
            small
            right
          >
            mdi-pencil
          </v-icon>
        </v-flex>
      </template>
    </v-layout>

    <v-layout row v-if="editing">
      <v-flex xs-12>
        <v-textarea
          hide-details
          :disabled="sending"
          :label="$t('Pilot.LogBook.EditMessage')"
          v-model="editStr"
          rows="3"
          auto-grow
        ></v-textarea>
        <div class="text-right">
          <v-btn :disabled="sending" @click="editing = false" small>{{ $t('Pilot.LogBook.Cancel') }}</v-btn>
          <v-btn color="primary" @click="sendMessage()" small :loading="sending">{{ $t('Pilot.LogBook.Send') }}</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloLogbookItem } from '../../models/alo/AloLogbookItem'
import { AloMission } from '@/models/alo/AloMission'

@Component({
  name: 'MissionDetailLogBookRow',
  props: {
    rowItem: {
      type: AloLogbookItem,
      required: true,
    },
    hideCycle: {
      type: Boolean,
      default: false,
    },
  },
})
export default class MissionDetailLogBookRow extends Vue {
  rowItem!: AloLogbookItem
  hideCycle!: boolean

  editStr = ''
  editing = false
  sending = false
  showHisto = false

  get userId() {
    return this.$store.myGetters?.userProfile?.id
  }

  get isAdmin() {
    return this.$store.myGetters?.isAdmin
  }

  get isSysAdmin() {
    return this.$store.myGetters?.isSysAdmin
  }

  get isManager() {
    return this.$store.myGetters?.isManager
  }

  edit() {
    this.editStr = this.rowItem.message
    this.editing = true
  }

  sendMessage() {
    this.sending = true
    if (this.rowItem.misId > -1)
      this.$store.myActions
        .MISSION_LOGBOOK_UPDATE_MESSAGE_REQUEST({
          misId: this.rowItem.misId,
          lbkId: this.rowItem.lbkId!,
          message: this.editStr.trim(),
        })
        .then(() => (this.editing = false))
        .finally(() => (this.sending = false))
    else if (this.rowItem.fleId > -1)
      this.$store.myActions
        .UI_FLEET_LOGBOOK_UPDATE_MESSAGE_REQUEST({
          fleId: this.rowItem.fleId,
          lbkId: this.rowItem.lbkId!,
          message: this.editStr.trim(),
        })
        .then(() => (this.editing = false))
        .finally(() => (this.sending = false))
  }

  showHistory() {
    if (this.isAdmin || this.isSysAdmin || this.isManager) {
      this.showHisto = !this.showHisto
    }
  }
}
</script>
<style scoped>
.borderlog {
  border-bottom: 1px solid #ccc;
}

.text-right {
  text-align: right;
}
.centercontent {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  text-align: center;
  min-width: min-content;
}

.leftcontent {
  border: none;
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 24px;
  min-width: min-content;
}
.modified {
  font-weight: bold;
  font-size: 11px;
  font-style: italic;
  padding-left: 3px;
  padding-right: 3px;
}
</style>
